import { FilterIcon } from "assets/icons";
import { If } from "components";
import { convertSearchParamsToObject } from "helpers";
import { useOnClickOutside } from "hooks";
import { useRef } from "react";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { Button } from "ui";

import { getTransactionsTableFilterNewSearchParams } from "../../helpers";
import { FilterFormValues, TransactionsFilterForm } from "../forms";
import { OrdersTableFilterProps } from "./TransactionsTableFilter.types";

import styles from "./TransactionsTableFilter.module.scss";

const TRANSACTIONS_FILTER_FORM_ID = "transactions-filter-form-id";

const TransactionsTableFilter = ({
  isLoading,
  isOpen,
  onClose,
  onToggle
}: OrdersTableFilterProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const containerRef = useRef(null);
  useOnClickOutside(containerRef, onClose);

  const submitFilterForm = (body: FilterFormValues) => {
    const existingParams = convertSearchParamsToObject(searchParams);
    const newParams = getTransactionsTableFilterNewSearchParams(body);

    setSearchParams(
      createSearchParams({
        ...existingParams,
        ...newParams
      })
    );

    onClose();
  };

  return (
    <div className={styles.transactions__filter} ref={containerRef}>
      <Button
        variant="primary"
        icon={<FilterIcon />}
        className={styles["transactions__filter--button"]}
        onClick={onToggle}
      />

      <If condition={isOpen}>
        <div className={styles["transactions__filter--content"]}>
          <TransactionsFilterForm
            formId={TRANSACTIONS_FILTER_FORM_ID}
            onSubmit={submitFilterForm}
            isLoading={isLoading}
          />
        </div>
      </If>
    </div>
  );
};

export default TransactionsTableFilter;
